<template>
  <div id="hrms75e-detail" class="hrms75e-detail">
    <div  class="hrms75e-box clearfix">
        <div class="col-md-5 panel-left">
          <detail-cours :labels="labels"
                        :detail="detail.cours"
                        :eventBtn="eventBtn"
                        :searchIndex="searchIndex"
                        :searchDetailCours="searchDetailCours"
                        :receivedHrms75eDetail="receivedHrms75eDetail"
                        :labelsButton="labelsButton"
                        :indexSelected="indexSelected"
                        :lovCurrentDesc="lovCurrentDesc"
                        :detailCoursColumns="detailCoursColumns"
                        :postHrms75eDetailCoursSave="postHrms75eDetailCoursSave"
                        :nowLang="nowLang" />
          <div class="box-footer">
            <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
          </div>
        </div>

        <div class="col-md-7 panel-right">
            <form class="form-horizontal">
              <div class="form-group margin-b-15">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC1']['40'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ codempid }} - {{ descCodempid }}</div>
                </div>
              </div>
            </form>

            <div class="box-tab">
                <div id="accordion">

                <detail-tab1 :labels="labels"
                             :labelsButton="labelsButton"
                             :nowLang="nowLang"
                             :detail="detail.tab1"
                             :detailTab1Columns="detailTab1Columns"
                             :setAddCodcours="setAddCodcours"/>
                <detail-tab2 :labels="labels"
                             :labelsButton="labelsButton"
                             :nowLang="nowLang"
                             :detail="detail.tab2"
                             :setAddCodcours="setAddCodcours"
                             :detailTab2Columns="detailTab2Columns"
                             :detailTab2Popup="detailTab2Popup"
                             :detailTab2PopupColumns="detailTab2PopupColumns"
                             :receivedHrms75eDetailTab2Popup="receivedHrms75eDetailTab2Popup" />
                <detail-tab3 :labels="labels"
                             :nowLang="nowLang"
                             :labelsButton="labelsButton"
                             :detail="detail.tab3"
                             :setAddCodcours="setAddCodcours"
                             :detailTab3MaxRowspan="detailTab3MaxRowspan"
                             :detailTab3Columns="detailTab3Columns" />
                <detail-tab4 :labels="labels"
                             :labelsButton="labelsButton"
                             :detail="detail.tab4"
                             :codempid="codempid"
                             :setAddCodcours="setAddCodcours"
                             :detailTab4Columns="detailTab4Columns"
                             :detailTab4Popup="detailTab4Popup"
                             :detailTab4PopupColumns="detailTab4PopupColumns"
                             :receivedHrms75eDetailTab4Popup="receivedHrms75eDetailTab4Popup" />
                <detail-tab5 :labels="labels"
                             :nowLang="nowLang"
                             :labelsButton="labelsButton"
                             :detail="detail.tab5"
                             :detailTab5MaxRowspan="detailTab5MaxRowspan"
                             :detailTab5Columns="detailTab5Columns" />

                </div>
            </div>
        </div>

      </div>

  </div>
</template>

<script>
import detailCours from 'components/hrms75e/detailCours'
import detailTab1 from 'components/hrms75e/detailTab1'
import detailTab2 from 'components/hrms75e/detailTab2'
import detailTab3 from 'components/hrms75e/detailTab3'
import detailTab4 from 'components/hrms75e/detailTab4'
import detailTab5 from 'components/hrms75e/detailTab5'

export default {
  name: 'hrms75e-detail',
  props: [ 'labels',
    'nowLang',
    'labelsButton',
    'toggle',
    'detail',
    'data',
    'labels',
    'eventBtn',
    'indexSelected',
    'receivedHrms75eDetail',
    'searchIndex',
    'searchDetailCours',
    'lovCurrentDesc',
    'postHrms75eDetailCoursSave',
    'detailCoursColumns',
    'detailTab1Columns',
    'detailTab2Columns',
    'detailTab2Popup',
    'detailTab2PopupColumns',
    'receivedHrms75eDetailTab2Popup',
    'detailTab3Columns',
    'detailTab3MaxRowspan',
    'detailTab4Columns',
    'detailTab4Popup',
    'detailTab4PopupColumns',
    'receivedHrms75eDetailTab4Popup',
    'detailTab5Columns',
    'detailTab5MaxRowspan',
    'codempid',
    'descCodempid',
    'setAddCodcours'
  ],
  components: {
    detailCours,
    detailTab1,
    detailTab2,
    detailTab3,
    detailTab4,
    detailTab5
  }
}
</script>

<style lang="scss">

.hrms75e-detail {

  .hrms75e-box {
    background: #FFF;
    width: 100%;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
  }

  .panel-left {
    padding: 20px 15px;
    border-right: 1px solid #BDBDBD;

      @media (max-width: 768px) {
        border-right: none;
        border-bottom: 1px solid #BDBDBD;
      }
  }

  .panel-right {
    margin-left: -1px;
    padding: 20px 15px;
    border-left: 1px solid #BDBDBD;

      @media (max-width: 768px) {
        border-left: none;
      }
  }
}

</style>



// WEBPACK FOOTER //
// detail.vue?12f59c48